export const constants = {
    dev_host: process.env.REACT_APP_DEVHOST,
    test_host: process.env.REACT_APP_TESTHOST
}